<template>
    <div>
        <el-form :model="searchForm" :inline="true" class="forTbFilter" @submit.native.prevent>
            <el-form-item label="所属代理商：">
                <el-input v-model.trim="searchForm.agentName" @keyup.enter.native="getListPageHandle" clearable></el-input>
            </el-form-item>
            <el-form-item label="供应商：">
                <el-select v-model="searchForm.supplierCode" placeholder="请选择" clearable filterable>
                    <el-option v-for="item in branchSupplierOption" :value="item.id" :key="item.id" :label="item.name"></el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="订单号：">
                <el-input v-model.trim="searchForm.orderNo" @keyup.enter.native="getListPageHandle" clearable></el-input>
            </el-form-item>
            <el-form-item label="ICCID号：">
                <el-input v-model.trim="searchForm.iccid" @keyup.enter.native="getListPageHandle" clearable></el-input>
            </el-form-item>
            <el-form-item label="来源订单号：">
                <el-input v-model.trim="searchForm.backOrderNo" @keyup.enter.native="getListPageHandle" clearable></el-input>
            </el-form-item>
            <el-form-item label="退款时间：" class="dateRange">
                <el-date-picker v-model="searchForm.time" range-separator="至" type="daterange" start-placeholder="开始日期" end-placeholder="结束日期" value-format="yyyy-MM-dd"></el-date-picker>
            </el-form-item>

            <el-form-item class="btnArea">
                <el-button type="primary" @click="getListPageHandle">搜索</el-button>
            </el-form-item>
        </el-form>
        <el-table :data="tbpg.tableData" border > 
            <el-table-column type="index" width="50" label="序号" ></el-table-column>
            <el-table-column prop="orderNo" label="订单号" width="170"></el-table-column>
            <el-table-column prop="agentPathNames" label="所属代理商" show-overflow-tooltip></el-table-column>
            <el-table-column label="ICCID号" width="160">
                <template slot-scope="scope">
                    <a href="javascript:void(0)" @click="goToDetailPage(scope.row)">{{ scope.row.iccid }}</a>
                </template>
            </el-table-column>
            <el-table-column prop="intoNo" label="接入号" width="130"></el-table-column>
            <el-table-column prop="packageName" label="套餐名" width="120"></el-table-column>
            <el-table-column prop="investStateName" label="充值状态" width="80"></el-table-column>
            <el-table-column prop="priceRmb" label="订单金额(元)" width="100"></el-table-column>
            <el-table-column prop="payStateName" label="支付状态" width="70"></el-table-column>
            <el-table-column prop="supplierName" label="供应商" width="100"></el-table-column>
            <el-table-column prop="createTime" label="退款时间" width="140"></el-table-column>
            <el-table-column prop="backOrderNo" label="来源订单号" width="170"></el-table-column>
            <el-table-column prop="backPriceRmb" label="退款金额(元)" width="100" ></el-table-column>
            <el-table-column label="退款原因"   show-overflow-tooltip>
                <template slot-scope="scope" >
                    {{scope.row.remark}}
                </template>
            </el-table-column>
            <el-table-column label="操作" width="60" >
                <template slot-scope="scope">
                    <el-button type="text" size="small" @click="showBackMoneyDetailDialog(scope.row.orderNo, $event)">详情</el-button>
                </template>            
            </el-table-column>
        </el-table>       
        <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="tbpg.currentPage"
            :page-sizes="[15, 50, 100, 500]"
            :page-size="tbpg.pageSize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="tbpg.total">
        </el-pagination>  
        <el-dialog :append-to-body="true"  title="退款详情" :visible.sync="backMoneyDetailVisible" width="1000px" :close-on-click-modal="false">
            <el-table :data="tbpg_back.tableData" border height="421">
                <el-table-column prop="orderNo" label="订单号" width="240"></el-table-column>
                <el-table-column prop="agentName" label="代理商名称"></el-table-column>
                <el-table-column prop="commissionRmb" label="退款金额（元）"></el-table-column>
                <el-table-column prop="remark" label="备注"></el-table-column>
            </el-table> 
            <el-pagination
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :current-page="tbpg_back.currentPage"
                :page-sizes="[10, 50, 100, 500]"
                :page-size="tbpg_back.pageSize"
                layout="total, sizes, prev, pager, next, jumper"
                :total="tbpg_back.total">
            </el-pagination> 
            <span slot="footer" class="dialog-footer">
                <el-button @click="backMoneyDetailVisible = false">关 闭</el-button>
            </span>   
        </el-dialog>
    </div>
</template>
<script>
import {backListPage, getSecondBackList} from '@/api/order.js'
import common from '@/utils/common.js'
export default {
    data(){
        return {
            searchForm: {
                agentName: '',
                supplierCode: '',
                iccid: '',
                orderNo: '',
                time: '',
                backOrderNo:''
            },
            branchSupplierOption: [],
            //退款订单列表
            tbpg: {
                tableData: [],
                currentPage: 1,
                pageSize: 15,
                total: 0
            },  
            //退款详情
            tbpg_back: {
                tableData: [],
                currentPage: 1,
                pageSize: 10,
                total: 0                
            },          
            publishNotifyVisibale: false,
            publishNotifyForm: {
                title: '',
                content: ''
            },
            confirmDialogVisible : false,//确认框
            backMoneyDetailVisible: false //退款详情
        }
    },
    methods: {
        goToDetailPage(row){
            this.$store.commit('menu/setFromPage', 'orderMgt');
            this.$store.commit('menu/setFromPageIccid', row.iccid);
            document.getElementById('cardDetailsMenu').click();
        },
        getListPageHandle($event){
            common.resetCurrentPage(this, $event, 'tbpg');
            var data = common.getRequestParams(this, 'tbpg', this.searchForm);
            backListPage(data).then(res => {
                common.listCallback(this, res, 'tbpg');
            })
        },
        handleSizeChange(val){
            if(this.backVisible){
                this.tbpg_back.pageSize = val;
                this.showSecondBackList(this.currentOrderNo_back);
            }else{
                this.tbpg.pageSize = val;
                this.getListPageHandle();
            }

        },
        handleCurrentChange(val){
            if(this.backVisible){
                this.tbpg_back.currentPage = val;
                this.showSecondBackList(this.currentOrderNo_back);
            }else{
                this.tbpg.currentPage = val
                this.getListPageHandle();                
            }
        },
        //“退款详情” 
        showBackMoneyDetailDialog(orderNo, $event){
            this.backMoneyDetailVisible = true;
            this.currentOrderNo_back = orderNo
            var searchForm = {
                orderNo: this.currentOrderNo_back
            }
            common.resetCurrentPage(this, $event, 'tbpg_back');
            var data = common.getRequestParams(this, 'tbpg_back', searchForm);
            getSecondBackList(data).then(res => {
                common.listCallback(this, res, 'tbpg_back');
            })
        },

    
    },
    created () {
        this.getListPageHandle();
        common.getBranchSupplierOptionCom(this, 'branchSupplierOption');
    },
}
</script>
<style lang="less">
.notifyDetail {
    h3 {
        text-align: center;
        margin-bottom: 10px;
    }
    p {
        text-indent: 2em;
        line-height: 1.5em;
    }
}
</style>

